export default {
    template: `<span style="color:gray">{{ displayValue }}</span>`,
    data: () => ({
        displayValue: null
    }),
    beforeMount() {
        this.displayValue = this.params.value;
    },
};